import { Controller } from "@hotwired/stimulus"

// Cierra la tarjeta de agradecimiento de las micro-preguntas de perfil.
// Solo del lado del cliente: el agradecimiento no necesita registrar nada.
export default class extends Controller {
  close() {
    this.element.closest("#pregunta-perfil")?.remove()
  }
}
